export default __webpack_public_path__ + "static/media/FrontPhoto.6f3e6376.png";